// Object copy/paste API wrapper — POSTs the clipboard's source + the paste target
// + options to the cross-connection copy orchestrator. Returns
// { results:[{kind,name,status,error,rows}], created, skipped, failed }.
import { api } from './api.js';

export async function copyObjects({ source, target, options }) {
  return api.post('/api/object-copy', { source, target, options });
}
